import React, {Component} from 'react';
import { Trans } from 'react-i18next';

import Scale from './Scale.jsx';

import IMG_PAISAJE_COLOR from '../img/paisaje-color.svg';
import IMG_PAISAJE_GRIS from '../img/paisaje-gris.svg';
import IMG_RETRATO_COLOR from '../img/retrato-color.svg';
import IMG_RETRATO_GRIS from '../img/retrato-gris.svg';

import IMG_COORDENADAS_COLOR from '../img/coordenadas.svg';
import IMG_COORDENADAS_GRIS from '../img/coordenadas-gris.svg';
import IMG_CUADRICULA_COLOR from '../img/cuadricula.svg';
// import IMG_CUADRICULA_GRIS from '../img/cuadricula-gris.svg';
import IMG_CUADRICULA_GRIS from '../img/cuadricula-gris.png';

import i18n from '../resources/i18n';
import {properties} from '../resources/properties.js';

class OptionMapSelectorSimple extends Component {
  constructor(props) {
    super(props);

    this.state = {
      firstRow: '25K',
      secondRow: '50K',
      activeRow: this.props.activeRow,
      orientation: this.props.orientation,
      orientationIMGPaisajeColor: IMG_PAISAJE_COLOR,
      orientationIMGPaisajeGris: IMG_PAISAJE_GRIS,
      orientationIMGRetratoColor: IMG_RETRATO_COLOR,
      orientationIMGRetratoGris: IMG_RETRATO_GRIS,
      coordinatesIMGColor: IMG_COORDENADAS_COLOR,
      coordinatesIMGGris: IMG_COORDENADAS_GRIS,
      gridIMGColor: IMG_CUADRICULA_COLOR,
      gridIMGGris: IMG_CUADRICULA_GRIS,
      radioButtonOneChecked: 'checked',
      radioButtonTwoChecked: 'checked',
      parentState: this.props.parentState
    };
    this.showHelpGrid = false;
    this.blockColor = true;
    this.showSpan = true;
    this.handleShowBarCode = this.handleShowBarCode.bind(this);
  }

  setStateGlobal = (state, event, value) => {
    const {setParentState} = this.props;
    setParentState(state, event);
  }

  setActiveRow = (event) => {
    if (event.target.value === 'secondRow') {
      this.props.actionScale('1:50.000');//, 'secondRow'
      if (this.showHelpGrid) {
        window.grid25Layer.setVisible(false);
        window.grid50Layer.setVisible(true);
      }

      window.mapJs.setMaxZoom(15);
      window.mapJs.removeLayers(window.mapJs.getLayers().find(l=>l.impl_.name === 'MTN'));
      window.mapJs.addLayers('TMS*MTN*https://tms-mapa-raster.ign.es/1.0.0/mapa-raster/{z}/{x}/{-y}.jpeg*true*false*14');
    } else {
      this.props.actionScale('1:25.000');//, 'firstRow'
      if (this.showHelpGrid) {
        window.grid50Layer.setVisible(false);
        window.grid25Layer.setVisible(true);
      }

      window.mapJs.setMaxZoom(18);
      window.mapJs.removeLayers(window.mapJs.getLayers().find(l=>l.impl_.name === 'MTN'));
      window.mapJs.addLayers('TMS*MTN*https://tms-mapa-raster.ign.es/1.0.0/mapa-raster/{z}/{x}/{-y}.jpeg*true*false*16');
    }
  }

  toggleHelpGrid = () => {
    if(this.showHelpGrid){
      window.grid50Layer.setVisible(false);
      window.grid25Layer.setVisible(false);
    }else{
      if(this.props.parentState.activeRow === 'secondRow'){
        window.grid50Layer.setVisible(true);
      }else{
        window.grid25Layer.setVisible(true);
      }
    }
    this.showHelpGrid = !this.showHelpGrid
    this.setStateGlobal(this.props.parentState);
  }

  changeSelectedScale = (option) => {
    let {parentState} = this.props;

    switch (option) {
      case '40K':

        if (parentState.activeRow === 'secondRow') {
          parentState.scale = '1:40.000';

        }
        break;
      case '20K':
        if (parentState.activeRow === 'firstRow') {
          parentState.scale = '1:20.000';

        }
        break;
      case '30K':
        if (parentState.activeRow === 'firstRow') {
          parentState.scale = '1:30.000';

        }
        break;
      case '50K':
        if (parentState.activeRow === 'secondRow') {
          parentState.scale = '1:50.000';

        }
        break;
      case '60K':
        if (parentState.activeRow === 'secondRow') {
          parentState.scale = '1:60.000';

        }
        break;
      default:
        if (parentState.activeRow === 'firstRow') {
          parentState.scale = '1:25.000';

        }
        break;
    }

    if ((['40K', '50K', '60K'].includes(option) && parentState.activeRow === "secondRow") || (['20K', '25K', '30K'].includes(option) && parentState.activeRow === "firstRow")) {
      this.props.actionScale(parentState.scale);//, option, parentState.activeRow

    }
    this.setStateGlobal(parentState);

  }

  // TEXTS

  setTitle = (event) => {
    let {parentState} = this.props;
    if (event.target.value === '') {
      parentState.title = event.target.placeholder;
    } else {
      parentState.title = event.target.value;
    }
    this.setStateGlobal(parentState);
  }
  setSubtitle = (event) => {
    let {parentState} = this.props;
    parentState.subtitle = event.target.value;
    this.setStateGlobal(parentState);

  }

  setAuthor = (event) => {
    let {parentState} = this.props;
    parentState.author = event.target.value;
    this.setStateGlobal(parentState);

  }
  setText = (event) => {
    let {parentState} = this.props;

    switch (event.target.name) {
      case 'textTitle':
        parentState.title = event.target.value;
        break;
      case 'textSubtitle':
        parentState.subtitle = event.target.value;
        break;
      case 'textAuthor':
        if (!parentState.specialMapGeneration) {
          parentState.author = event.target.value;
        }
        break;
//Mapa Especial
      case 'textNipo':
        parentState.nipo = event.target.value;
        break;
      case 'textISBN':
        parentState.isbn = event.target.value;
        break;
      case 'textDepositoLegal':
        parentState.depositoLegal = event.target.value;
        break;
//Mapa Especial
      default:
        parentState.title = event.target.value;
    }
    this.setStateGlobal(parentState);
  }

  handleShowBarCode(){
    this.props.actionShowBarCodePopup();
  }

  handleChangeImageBarras = (event) => {
    let {parentState} = this.props;
    let reader = new FileReader();
    let file = event.target.files[0];
    if (file.size > properties.MAX_POST_SIZE) {
      event.target.value = null;
      this.handleShowBarCode();
      return;
    }
    parentState.specialFileName = file.name;
    let img = new Image();
    reader.onload = (upload) => {
      img.src = upload.target.result;
    };
    img.onload = () => {
      this.blockColor = false;
      this.showSpan = false;
      var oc = document.createElement('canvas'),
      octx = oc.getContext('2d');
      oc.width = img.width;
      oc.height = img.height;
      octx.drawImage(img, 0, 0, oc.width, oc.height);
      parentState.codigoBarras = oc.toDataURL();
      parentState.realCodigoBarras = parentState.codigoBarras;
      this.setState({});
    }
    reader.readAsDataURL(file);
  }

  clearCodigoBarras = (event) => {
    let {parentState} = this.props;
    this.blockColor = true;
    this.showSpan = true;
    event.target.parentElement.childNodes[0].value = null;
    event.target.parentElement.childNodes[0].files = null;
    parentState.codigoBarras = null;
    parentState.realCodigoBarras = null;
    parentState.specialFileName = null;
    this.setState({});
  }

  render() {

    const {
      asideClassName, classPanelButton, classPanelContent,
      // scaleValueChild,
      parentState
    } = this.props;

    let placeholderFile;
    if(parentState){
      placeholderFile = (parentState.codigoBarras? (parentState.specialFileName?parentState.specialFileName:i18n.t('step2.selectedFile')) :i18n.t('step2.notSelectedFile')) || (parentState.codigoBarras ? 'Archivo previamente seleccionado.' : 'Archivo no seleccionado.');
    } else {
      placeholderFile = parentState.codigoBarras ? (parentState.specialFileName?parentState.specialFileName:'Archivo previamente seleccionado.') : 'Archivo no seleccionado.';
    }

    return (<aside className={asideClassName}>
      <div className={classPanelButton}>
        <div className='open'>
          <i className='fas fa-arrow'></i>
        </div>
      </div>
      <div className={classPanelContent}>
        {/* PRODUCTO */}
        <h2 className="h2Custom"><Trans i18nKey="step1.product">Producto</Trans></h2>
        <div className="scale first-step" style={{position:"relative"}}>

          <div className="radiobutton-row center scaleOption">
            <span><input type="radio" id="opt1" name="drone" value="firstRow" checked={parentState.activeRow === 'firstRow'} onChange={this.setActiveRow}/>
            <label htmlFor="opt1">1:25.000</label></span>
            <div className="showGridHelp" style={{display:parentState.activeRow === 'firstRow'?"flex":"none"}}>
              <input id="opt1_grid" type="checkbox" checked={this.showHelpGrid} onClick={this.toggleHelpGrid} readOnly />
              <label style={{display: "inline-block"}}><Trans i18nKey="step1.seeGrid">Visualizar cuadrículas</Trans></label>
            </div>
          </div>

          <div className="radiobutton-row center scaleOption">
            <span><input type="radio" id="opt2" name="drone" value="secondRow" checked={parentState.activeRow === 'secondRow'} onChange={this.setActiveRow}/>
            <label htmlFor="opt2">1:50.000</label></span>
            <div className="showGridHelp" style={{display:parentState.activeRow === 'secondRow'?"flex":"none"}}>
              <input id="opt2_grid" type="checkbox" checked={this.showHelpGrid} onClick={this.toggleHelpGrid} readOnly />
              <label style={{display: "inline-block"}}><Trans i18nKey="step1.seeGrid">Visualizar cuadrículas</Trans></label>
            </div>
          </div>
        </div>
        {/* ESCALA */}
        <h2 className="h2Custom fullScreenScaleREF"><Trans i18nKey="step1.scale">Escala</Trans></h2>
        <div className="scale second-step">

          <div className="radiobutton-row center scaleMenu">
            { this.props.parentState.activeRow === 'firstRow' ? (<React.Fragment>
            <Scale scale={parentState.scale} className='small' classNameActive='small active' label='30K' tooltipText='1:30.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
            <Scale scale={parentState.scale} className='medium' classNameActive='medium active' label='25K' tooltipText='1:25.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
            <Scale scale={parentState.scale} className='large' classNameActive='large active' label='20K' tooltipText='1:20.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
            </React.Fragment>) : <React.Fragment>
            <Scale scale={parentState.scale} className='small' classNameActive='small active' label='60K' tooltipText='1:60.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
            <Scale scale={parentState.scale} className='medium' classNameActive='medium active' label='50K' tooltipText='1:50.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
            <Scale scale={parentState.scale} className='large' classNameActive='large active' label='40K' tooltipText='1:40.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
            </React.Fragment>}
          </div>
        </div>

        {/* TEXT */}
        <h2 className="h2Custom"><Trans i18nKey="step2.texts">Textos</Trans></h2>
        <div className="texts-row-simple third-step">

          <div className="texts">
            <input type="text" id="titleStep2" name="textTitle" maxLength="35" placeholder={i18n.t('step2.title')+'*'} value={parentState.title} onChange={this.setText} required="required"/>
          </div>
          <div className="texts">
            <input type="text" name="textSubtitle" maxLength="45" placeholder={i18n.t('step2.subtitle')} value={parentState.subtitle} onChange={this.setText} onKeyDown={this.setSubtitle}/>
          </div>
          <div className="texts">
            <input type="text" id="textAuthor" name="textAuthor" maxLength="30" placeholder={i18n.t('step2.author')+'*'} value={parentState.author} onChange={this.setText} onKeyDown={this.setAuthor} required="required" disabled={parentState.specialMapGeneration}/>
          </div >
          {parentState.specialMapGeneration && (<div className="texts-row">
            <div className="texts">
              <input type="text" id="textNipo" name="textNipo" maxLength="12" value={parentState.nipo} placeholder='NIPO* 123-45-678-9' onChange={this.setText} required="required"/>
            </div>
            <div className="texts">
              <input type="text" id="textISBN" name="textISBN" maxLength="17" value={parentState.isbn} placeholder='ISBN* 978-76-543-2101-2' onChange={this.setText} required="required"/>
            </div>
          </div>)}
          {parentState.specialMapGeneration && (<div className="texts-row">
            <div className="texts">
              <input type="text" id="textDepositoLegal" name="textDepositoLegal" maxLength="12" placeholder={i18n.t('step2.depLegal')+'* M-25394-2022'} value={parentState.depositoLegal} onChange={this.setText} required="required"/>
            </div>
            <div className="texts">
              <div className={this.blockColor?'blockedColor':''} style={{position: 'relative'}}>
                {this.showSpan &&(<span className='placeholderFileInput'>{placeholderFile}</span>)}
                <input type="file" accept=".jpg,.png,.jpeg" id="imagenCodigoBarras" name="imagenCodigoBarras" onChange={this.handleChangeImageBarras} required={parentState.codigoBarras?false:'required'} style={{width: '100%'}}/>
                <button className='removeFileClass' onClick={this.clearCodigoBarras}>X</button>
              </div>
              <label><Trans i18nKey="step2.codBar">Código de Barras</Trans> (<label className="labelRed">*</label>)</label>
            </div>
          </div>)}
          {parentState.specialMapGeneration && (<div className="texts-row">
            <img src={parentState.codigoBarras} alt="*Barcode*" className="exampleBarcode"></img>
          </div>)}
        </div>

      </div>

    </aside>);
  }
}
export default OptionMapSelectorSimple;
